import { createContext, useContext, useEffect, useState } from "react";
import { api, clearToken } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out
  const [notifCount, setNotifCount] = useState(0);

  const loadUser = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  };

  const refreshNotifs = async () => {
    try {
      const { data } = await api.get("/notifications");
      setNotifCount(data.filter((n) => !n.read).length);
    } catch (e) { console.debug("refreshNotifs failed", e?.message); }
  };

  useEffect(() => { loadUser(); }, []);
  useEffect(() => {
    if (user) {
      refreshNotifs();
      const t = setInterval(refreshNotifs, 10000);
      return () => clearInterval(t);
    }
  }, [user]);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { console.debug("logout request failed", e?.message); }
    clearToken();
    setUser(false);
  };

  const hasFeature = (k) => !!(user && Array.isArray(user.entitlements) && user.entitlements.includes(k));

  return (
    <AuthContext.Provider value={{ user, setUser, logout, notifCount, refreshNotifs, loadUser, hasFeature }}>
      {children}
    </AuthContext.Provider>
  );
}
